import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Trash2 } from "react-feather";
import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import { Table } from "antd";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import withReactContent from "sweetalert2-react-content";
import AddRole from "../../core/modals/usermanagement/addrole.jsx";
import EditRole from "../../core/modals/usermanagement/editrole.jsx";

import { APIgetRoles, APIDeleteRole } from "../../api/settings.ts";

const StoreList = () => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const [dataRole, setDataRole] = useState([]);
  const [editRole, setEditRole] = useState({});
  //const [loading, setLoading] = useState(false);

  const MySwal = withReactContent(Swal);

  const fetchRoles = async () => {
   // setLoading(true);
    try {
      const res = await APIgetRoles({});
      if (res?.response?.roles) {
        setDataRole(res.response.roles.reverse());
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
   //   setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setEditRole(record);
  };

  const handleDelete = async (record) => {
    try {
      const result = await MySwal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00ff00",
        confirmButtonText: "Yes, delete it!",
        cancelButtonColor: "#ff0000",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        const res = await APIDeleteRole({ id: record._id });
        if (res) {
          await MySwal.fire({
            title: "Deleted!",
            text: "Role has been deleted.",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          fetchRoles(); // Refetch roles after deletion
        } else {
          throw new Error("Deletion failed");
        }
      }
    } catch (error) {
      await MySwal.fire({
        title: "Error!",
        text: error.message || "An error occurred while deleting the role.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
    }
  };
  //Permissions  
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'update');
  const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'delete');

  const columns = [
    {
      title: t[l]?.["role_name"] || 'Role Name',
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: t[l]?.["description"] || 'Description',
      dataIndex: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },
    {
      title: t[l]?.["action"] || 'Actions',
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
          {canUpdate && (
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={() => handleEdit(record)}
            >
              <Edit className="feather-edit" />
            </Link>
             )}
            {canDelete && (
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => handleDelete(record)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
              )}
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleAddRoleClick = () => {
    setEditRole({}); // Reset editRole when adding a new role
  };

  return (
    <div>
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
           {canView ? (
        <div className="content">
<div className="page-header">
            <div className="add-item d-flex">
                <div className="page-title">
                    <h4>{t?.[l]?.["roles_permissions"] || "Roles & Permissions"}</h4>
                    <h6>{t?.[l]?.["manage_your_roles_permissions"] || "Manage Your Roles & Permissions"}</h6>
                </div>
            </div>
        
        
{canCreate ? (
          <div className="page-btn">
          <Link
              to="#"
              className="btn btn-added"
              data-bs-toggle="modal"
              data-bs-target="#add-roles"
              onClick={handleAddRoleClick}
          >
              <PlusCircle className="me-2" />
              {t?.[l]?.["add_role"] || "Add Role"}
          </Link>
          </div>

        ) : null}
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={dataRole}
                rowKey={(record) => record.id}
                // loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
        ) : (
          <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
              <div className="content">
                  <p>{t[l]?.["no_permission"] || "You do not have permission to view this page."}</p>
              </div>
          </div>
      )}
      
       {
        canView && <EditRole edit={editRole} refetchRole={fetchRoles} /> 
      }
      {
        <AddRole refetchRole={fetchRoles} /> 
      }
      </div>
    </div>
  );
};

export default StoreList;
